import axiosInstance from "./axiosInstance";

export const getAllMenus = async () => {
  const res = await axiosInstance.get(`/menus/all`);
  return res.data;
};

export const assignCompanyMenus = async (companyId, { permissions }) => {
  try {
    const menuAssignments = permissions.map(({ menuId, roles, isActive }) => ({
      menuId,
      roles,
      isActive,
    }));

    const response = await axiosInstance.post(`/menus/assign`, {
      companyId,
      menuAssignments,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCompanyMenuAssignments = async (companyId) => {
  try {
    const response = await axiosInstance.get(`/companies/${companyId}/assignments`);

    if (response.data.status === "success") {
      return response.data.data;
    }
    return null;
  } catch (error) {
    console.warn("Menu Error:", error);
  }
};
